import React, { useState, useContext, useEffect } from "react";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import TimeSheetDetalhesContext from "../../contexts/TimeSheetDetalhesContext";
import api from '../../services/api';
import Swal from "sweetalert2";

export const ModalNotifyGrupo = ({ isOpen, onAfterOpen, onRequestClose, loadPage, selectedGrupoAtividade }) => {
    var [descricao, setDescricao] = useState(null);
    const { timesheet } = useContext(TimeSheetDetalhesContext);
    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '25%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const handleDescricao = (valor) => {
        descricao = valor;
        setDescricao(descricao);
    }

    const registrationSuccess = () => {
        Swal.fire({
            title: "Sucesso",
            text: "Notificação cadastrada com sucesso",
            icon: "success",
            timer: 2500
        });
    };

    const registrationFailure = (text = "Ops, ocorreu um erro ao realizar o cadastro. Tente novamente em instantes.") => {
        Swal.fire({
            title: "Atenção",
            text: text,
            icon: "error",
            confirmButtonText: "OK",
        });
    };


    const formActivities = async () => {
        if (!descricao?.target?.value) return;
        let payload = {
            Mensagem: descricao.target.value,
            IdTimesheetItemGruposAtividades: selectedGrupoAtividade?.Value?.map(item => item.idTimesheetItemGrupoAtividade),
            referencia: timesheet?.pericia?.sigla ?? timesheet?.regulacao?.sigla
        }

        await api.post(`Timesheet/grupo-atividade/notificar`, payload)
            .then(async (response) => {
                onRequestClose(false);
                registrationSuccess();
                loadPage();
            })
            .catch((error) => {
                registrationFailure(error?.response?.data?.notification?.messageReturn)
            });
    }

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="Timesheet Atividades"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={onRequestClose}>X</p>
            </StyledForm>
            <Flex>
                <StyledForm style={{ width: "100%" }}>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <p className="modal-title">Notificação de Grupo de Atividade</p>
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div style={{ width: '100%' }} className="position-relative form-group">
                                <textarea rows="3" className="input-form" placeholder='Mensagem' name='Mensagem' onBlur={handleDescricao} />
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group modal-align-center">
                                <input className='default-button-red' value='Notificar' onClick={formActivities} type="button" />
                            </div>
                        </Flex.Item>
                    </Flex>
                </StyledForm>
            </Flex>
        </Modal>
    );
};